import React from 'react';
import Box from '@amzn/meridian/box';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import alertFilledTokens from '@amzn/meridian-tokens/base/icon/alert-filled';
import { colorYellow300 } from '@amzn/meridian-tokens/base/color';

interface SimulationBanner {
  title: string;
}

const SimulationBannerComponent: React.FC<SimulationBanner> = ({ title }) => (
  <Box backgroundColor={colorYellow300} spacingInset="small medium" role="status">
    <Row alignmentHorizontal="center" spacing="small">
      <Icon tokens={alertFilledTokens} />
      <Text type="b300">{title}</Text>
    </Row>
  </Box>
);

export default SimulationBannerComponent;
